import { APIPath } from 'utility/constant'
import { BaseService } from './base'

class EscalationPolicyServiceClass {
    list() {
        return BaseService.get(APIPath.actionPlanEscalationPolicy)
    }

    getById(policyId) {
        return BaseService.get(APIPath.actionPlanEscalationPolicyById(policyId))
    }

    create(data) {
        return BaseService.post(APIPath.actionPlanEscalationPolicy, data)
    }

    update(policyId, data) {
        return BaseService.put(
            APIPath.actionPlanEscalationPolicyById(policyId),
            data,
        )
    }

    remove(policyId) {
        return BaseService.remove(
            APIPath.actionPlanEscalationPolicyById(policyId),
        )
    }

    attachToRule(ruleId, policyId) {
        return BaseService.post(
            APIPath.actionPlanRuleEscalationPolicy(ruleId, policyId),
        )
    }

    unlinkFromRule(ruleId) {
        return BaseService.remove(
            APIPath.actionPlanRuleEscalationPolicyUnlink(ruleId),
        )
    }

    getTicketWatchers(ticketId) {
        return BaseService.get(APIPath.actionPlanTicketWatcher(ticketId))
    }

    addTicketWatcher(ticketId, data) {
        // Postman body is exact DTO — do not inject LoginSource / TicketId into JSON
        return BaseService.postExact(
            APIPath.actionPlanTicketWatcher(ticketId),
            data,
        )
    }

    removeTicketWatcher(ticketId, watcherId) {
        return BaseService.remove(
            APIPath.actionPlanTicketWatcherById(ticketId, watcherId),
        )
    }
}

export const EscalationPolicyService = new EscalationPolicyServiceClass()
